import { render } from "./CommissionsAnalytics.vue?vue&type=template&id=6c0cb570"
import script from "./CommissionsAnalytics.vue?vue&type=script&lang=js"
export * from "./CommissionsAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__